var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopRecorderActionsEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_586_2067)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 20,
    width: 20,
    height: 20,
    rx: 10,
    transform: "rotate(-90 4 20)",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7283 4.37594C11.9916 3.98384 13.4293 4.28881 14.4312 5.29078C15.5203 6.37988 15.7817 8.03522 15.1718 9.38561L19.3974 13.5678C19.9201 14.0905 19.9201 14.9182 19.3974 15.3974C18.9183 15.9202 18.0906 15.9202 17.5677 15.3974L13.3421 11.1718C12.0353 11.7817 10.3798 11.5204 9.29073 10.4313C8.28876 9.42929 7.98387 7.99182 8.37589 6.72834C8.46303 6.46694 8.768 6.42338 8.94219 6.59764L11.1203 8.77573C11.2074 8.86286 11.4252 8.86286 11.5559 8.77573L12.7757 7.55593C12.8628 7.42523 12.8628 7.20739 12.7757 7.12033L10.5976 4.94225C10.4233 4.76798 10.4669 4.46308 10.7283 4.37594Z",
    fill: "#999999"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_586_2067",
    x: 0.315789,
    y: 0,
    width: 27.3684,
    height: 27.3684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.68421
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84211
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_586_2067"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_586_2067",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopRecorderActionsEdit);
export default __webpack_public_path__ + "static/media/desktop-recorder-actions-edit.d7c60b9626604aecafc984c7dd2a9208.svg";
export { ForwardRef as ReactComponent };